/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * tag type
 */
export enum SeoTagType {
  SR_ARTWORKS = 'sr-artworks',
  POSTERS = 'posters',
}
